import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var basePre = 'operation-center';
var pre = 'smallprogram';
var meta = {
  auth: true,
  closable: true,
  showMenu: false,
  refresh: true
};
export default [{
  path: "/".concat(basePre, "/").concat(pre, "/join-information-detail/:type?"),
  title: '新增招商问答',
  name: "join-information-add",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '新增招商问答',
    activePath: "/".concat(basePre, "/").concat(pre, "/join/information")
  }),
  component: "pages/".concat(basePre, "/").concat(pre, "/join/information/detail.vue")
}, {
  path: "/".concat(basePre, "/").concat(pre, "/join-information-detail/:id?"),
  title: '招商问答详情',
  name: "join-information-detail",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '招商问答详情',
    activePath: "/".concat(basePre, "/").concat(pre, "/join/information")
  }),
  component: "pages/".concat(basePre, "/").concat(pre, "/join/information/detail.vue")
}, {
  path: "/".concat(basePre, "/").concat(pre, "/join-information-list"),
  title: '招商问答列表',
  name: "join-information-list",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '招商问答列表',
    activePath: "/".concat(basePre, "/").concat(pre, "/join/information")
  }),
  component: "pages/".concat(basePre, "/").concat(pre, "/join/information/list.vue")
}];